import { trpc } from '@tencent/tpro_rmonitor_manage_server_continuous_event';
import { BusiCode } from '@/infrastructure/axios/code';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { TrpcService } from '@/service/trpc';
import { WithTypeCast } from '@raft/utils';

export type IGetProductConfigReq = WithTypeCast<trpc.rmonitor.manage_server.IGetProductConfigReq>;
export type IGetProductConfigRsp = WithTypeCast<trpc.rmonitor.manage_server.IGetProductConfigRsp>;
export type IContinuationDef = WithTypeCast<trpc.rmonitor.manage_server.IContinuationDef>;
export type IUpdateProductConfigReq = WithTypeCast<trpc.rmonitor.manage_server.IUpdateProductConfigReq>;
export type IUpdateProductConfigRsp = WithTypeCast<trpc.rmonitor.manage_server.IUpdateProductConfigRsp>;


/**
 * 连续崩溃
 */
export class ContinuousEventService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.ContinuousEvent,
    });
  }
  // 获取数据
  public async getProductConfig(req: IGetProductConfigReq): Promise<IContinuationDef> {
    try {
      const rsp = await this.trpcPost<IGetProductConfigRsp>('GetProductConfig', req);
      return rsp.def ?? {};
    } catch (e) {
      return {};
    }
  }
  // 更新
  public async updateProductConfig(req: IUpdateProductConfigReq): Promise<boolean> {
    try {
      const resp = await this.trpcPost<IUpdateProductConfigRsp>('UpdateProductConfig ', req);

      return resp.baseRsp?.code === BusiCode.Ok;
    } catch (e) {
      return false;
    }
  }
}

export const continuousEventService = new ContinuousEventService();
